module.exports = __webpack_public_path__ + "img/logo.5ae76924.jpg";